import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { adminApi, getToken, setToken } from './api';
import AdminLayout from './AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SettingsPage from './pages/SettingsPage';
import ProductsPage from './pages/ProductsPage';
import PromptPage from './pages/PromptPage';
import AppointmentsPage from './pages/AppointmentsPage';
import EmbedPage from './pages/EmbedPage';

function RequireAuth({ children }) {
  const [status, setStatus] = useState(getToken() ? 'checking' : 'anon');

  useEffect(() => {
    if (!getToken()) return;
    adminApi
      .me()
      .then(() => setStatus('ok'))
      .catch(() => {
        setToken(null);
        setStatus('anon');
      });
  }, []);

  if (status === 'checking') {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (status === 'anon') return <Navigate to="/admin/login" replace />;
  return children;
}

export default function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="impostazioni" element={<SettingsPage />} />
        <Route path="prodotti" element={<ProductsPage />} />
        <Route path="prompt" element={<PromptPage />} />
        <Route path="appuntamenti" element={<AppointmentsPage />} />
        <Route path="embed" element={<EmbedPage />} />
      </Route>
    </Routes>
  );
}
